import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

export const NavLink = ({ href, children, subRoutes = [] }) => {
  const router = useRouter();
  let className = children.props.className || '';

  if (router.pathname === href) {
    className = `${className} active`;
  }

  if (router.pathname.includes(href) && href != '/') {
    className = `${className} active`;
  }

  if (subRoutes.length > 0) {
    if (subRoutes.includes(router.pathname)) className = `${className} active`;
  }

  return <Link href={href}>{React.cloneElement(children, { className })}</Link>;
};

export default NavLink;
